import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'components/Button/Button';
import TextInput from 'components/TextInput/TextInput';
import {
  getSelectedLegend,
  getIsCreatingLegendItem,
  setIsCreatingLegendItem,
  updateLegend,
  deleteLegend,
  getPickedLegendColor,
  getPickedLegendText,
  getPickedLegendTool,
  setSelectedLegend,
} from '../../../../../store/lixaniPaint/slices/drawingToolSlice';

export const LegendSettings = () => {
  const dispatch = useDispatch();
  const selectedLegend = useSelector(getSelectedLegend);
  const isPickingColor = useSelector(getIsCreatingLegendItem);
  const pickedColor = useSelector(getPickedLegendColor);
  const pickedText = useSelector(getPickedLegendText);
  const pickedTool = useSelector(getPickedLegendTool);
  const [selectedColor, setSelectedColor] = useState('#000000');
  const [itemText, setItemText] = useState('');
  const [selectedTool, setSelectedTool] = useState('');

  useEffect(() => {
    if (pickedColor && pickedText) {
      setSelectedColor(pickedColor);
      setItemText(pickedText);
      setSelectedTool(pickedTool);
    }
  }, [pickedColor, pickedText, pickedTool]);

  if (!selectedLegend) return null;

  const handleColorPicker = () => {
    dispatch(setIsCreatingLegendItem(!isPickingColor));
  };

  const addLegendItem = () => {
    if (!itemText.trim()) return;
    const updatedLegend = {
      ...selectedLegend,
      items: [
        ...selectedLegend.items,
        {
          color: selectedColor,
          text: itemText,
          tool: selectedTool,
          icon: '⬜',
        },
      ],
    };
    dispatch(updateLegend(updatedLegend));
    setItemText('');
  };

  const deleteLegendItem = (index) => {
    const updatedLegend = {
      ...selectedLegend,
      items: selectedLegend.items.filter((_, i) => i !== index),
    };
    dispatch(updateLegend(updatedLegend));
  };

  const deleteEntireLegend = () => {
    dispatch(deleteLegend({ id: selectedLegend.id }));
    dispatch(setSelectedLegend(null));
  };

  return (
    <div style={{ padding: '16px', color: 'white' }}>
      <Button
        onClick={handleColorPicker}
        color={isPickingColor ? 'danger' : 'primary'}
        fullWidth
        size="small"
        style={{ marginBottom: '16px' }}
      >
        {isPickingColor
          ? 'Klikkaa haluttua elementtiä'
          : 'Aloita elementin valinta'}
      </Button>

      <div style={{ marginBottom: '16px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '12px',
          }}
        >
          <div
            style={{
              width: '32px',
              height: '32px',
              backgroundColor: 'rgba(255,255,255,0.1)',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: '4px',
              position: 'relative',
              flexShrink: 0,
            }}
          >
            {pickedText === 'Teksti' ? (
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: selectedColor,
                  fontSize: '14px',
                  fontWeight: 'bold',
                }}
              >
                Aa
              </div>
            ) : (
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  backgroundColor: selectedColor,
                  borderRadius: '3px',
                }}
              />
            )}
          </div>
          <span style={{ fontSize: '14px', opacity: 0.9 }}>Selitteen väri</span>
        </div>

        <TextInput
          placeholder="Seliteteksti"
          value={itemText}
          onChange={(e) => setItemText(e.target.value)}
          fullWidth
          margin="dense"
          style={{ marginBottom: '12px' }}
        />

        <div style={{ display: 'flex', gap: '8px' }}>
          <Button
            onClick={addLegendItem}
            disabled={!itemText.trim()}
            color="secondary"
            size="small"
            style={{ flex: 1 }}
          >
            Lisää selite
          </Button>

          <Button
            onClick={deleteEntireLegend}
            color="danger"
            size="small"
            style={{ flex: 1 }}
          >
            Poista selite
          </Button>
        </div>
      </div>

      <div style={{ marginTop: '20px' }}>
        <h5
          style={{
            margin: '0 0 12px 0',
            fontSize: '14px',
            fontWeight: 500,
            opacity: 0.9,
          }}
        >
          Selitteen sisältö ({selectedLegend.items?.length || 0}):
        </h5>
        {selectedLegend.items && selectedLegend.items.length > 0 ? (
          <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {selectedLegend.items.map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  marginBottom: '8px',
                  padding: '8px',
                  backgroundColor: 'rgba(255,255,255,0.05)',
                  borderRadius: '4px',
                  border: '1px solid rgba(255,255,255,0.1)',
                }}
              >
                <div
                  style={{
                    width: '16px',
                    height: '16px',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    border: '1px solid rgba(255,255,255,0.2)',
                    borderRadius: '2px',
                    position: 'relative',
                    flexShrink: 0,
                  }}
                >
                  {item.text === 'Teksti' ? (
                    <div
                      style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: item.color,
                        fontSize: '10px',
                        fontWeight: 'bold',
                      }}
                    >
                      Aa
                    </div>
                  ) : (
                    <div
                      style={{
                        width: '100%',
                        height: '100%',
                        backgroundColor: item.color,
                        borderRadius: '1px',
                      }}
                    />
                  )}
                </div>
                <span
                  style={{
                    flex: 1,
                    fontSize: '13px',
                    opacity: 0.9,
                  }}
                >
                  {item.text}
                </span>
                <Button
                  onClick={() => deleteLegendItem(index)}
                  color="danger"
                  size="small"
                  style={{
                    minWidth: '24px',
                    width: '24px',
                    height: '24px',
                    padding: 0,
                    fontSize: '12px',
                  }}
                >
                  ×
                </Button>
              </div>
            ))}
          </div>
        ) : (
          <p
            style={{
              fontSize: '12px',
              opacity: 0.6,
              fontStyle: 'italic',
              margin: 0,
            }}
          >
            Ei sisältöä
          </p>
        )}
      </div>
    </div>
  );
};

export const setLegendColor = (color, setSelectedColor) => {
  setSelectedColor(color);
};
